import React, { useEffect, useState } from 'react';
import { Filter as CommonFilter } from '@blueprintnyc/bpnyc-common-admin';

const Filter = props => {
	const { data, selected, onChange, multiselect, filter, placeholder } = props;
	const [options, setOptions] = useState([]);
	const [selectedArr, setSelectedArr] = useState([]);

	useEffect(() => {
		if (data && data.length) {
			const opts = data.map(a => ({
				id: a.id,
				name: filter === 'person' ? `${a.first_name} ${a.last_name}` : `${a.name}`,
			}));
			setOptions(opts);
		}
		return () => {
			setOptions([]);
		};
	}, [data]);

	useEffect(() => {
		if (data && data.length && selected && selected.length) {
			if (Array.isArray(selected)) {
				setSelectedArr(selected);
			} else {
				const selectedObj = data.find(obj =>
					filter === 'person'
						? `${obj.first_name} ${obj.last_name}` === selected
						: `${obj.name}` === selected
				);
				if (selectedObj && selectedObj.id) setSelectedArr([selectedObj.id]);
			}
		} else {
			setSelectedArr([]);
		}
	}, [selected, data]);

	const filterProps = {
		options,
		selected: selectedArr,
		onChange,
		multiselect,
		placeholder,
	};

	return <CommonFilter {...filterProps} />;
};

export default Filter;
